export default function CalendarSection() {
  const openCalendar = () => {
    // @ts-expect-error - Cal is loaded dynamically from external script
    if (window.Cal) {
      // @ts-expect-error - Cal namespace is configured in index.html
      window.Cal.ns["agente-virtual"]("ui", {
        hideEventTypeDetails: false,
        layout: "month_view"
      });
    }
  };

  return (
    <section id="demo-section" className="py-16 sm:py-20 md:py-24 bg-gradient-to-b from-[#0a0e27] to-[#1a1f3a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-8 sm:mb-12">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-white mb-4 sm:mb-6 px-4">
            Agenda tu{' '}
            <span className="bg-gradient-to-r from-cyan-400 to-purple-500 bg-clip-text text-transparent">
              Entrevista Estratégica
            </span>
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-300 max-w-3xl mx-auto px-4">
            Selecciona el día y hora que mejor te convenga para hablar sobre cómo implementar un agente de voz en tu negocio.
          </p>
        </div>

        <div className="bg-gradient-to-br from-[#1a1f3a]/80 to-[#0a0e27]/80 backdrop-blur-lg rounded-3xl p-4 sm:p-6 md:p-8 border border-cyan-500/20 shadow-2xl shadow-cyan-500/10">
          <div className="text-center">
            <button
              onClick={openCalendar}
              data-cal-link="fundador/agente-virtual"
              data-cal-namespace="agente-virtual"
              data-cal-config='{"layout":"month_view","useSlotsViewOnSmallScreen":"true"}'
              className="inline-flex items-center gap-3 px-8 sm:px-12 py-4 sm:py-5 bg-gradient-to-r from-cyan-500 to-purple-600 text-white text-lg sm:text-xl font-bold rounded-full overflow-hidden transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-cyan-500/50 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-line text-2xl sm:text-3xl"></i>
              <span>Abrir Calendario</span>
            </button>
            <p className="text-sm sm:text-base text-gray-400 mt-6">
              Haz clic en el botón para ver la disponibilidad y agendar tu cita
            </p>
          </div>
        </div>

        <div className="text-center mt-8 sm:mt-10">
          <p className="text-sm sm:text-base text-gray-400">
            Powered by{' '}
            <a 
              href="https://cal.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-cyan-400 hover:text-cyan-300 underline transition-colors"
            >
              Cal.com
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}
